module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Billionaire's Bride of Innocence")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "application/xhtml+xml; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm03"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("All about the author…"), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Miranda Lee")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("MIRANDA LEE")])]), _vm._v(" was born at Port Macquarie, a popular seaside town on the mid-north coast of New South Wales, Australia. Her father was a country schoolteacher and brilliant sportsman. Her mother was a talented dressmaker.")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("After leaving her convent school, Miranda briefly studied the cello before moving to Sydney, where she embraced the emerging world of computers. Her career as a programmer ended after she married, had three daughters and bought a small acreage in a semirural community.")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("Miranda attempted greyhound training, as well as horse and goat breeding, but was left dissatisfied. She yearned to find a creative career from which she could earn money. When her sister suggested writing romances, it seemed like a good idea. She could do it at home, and it might even be fun!")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("It took a decade of trial and error before her first romance, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("After the Affair,")])]), _vm._v(" was accepted and published. At that time, Miranda, her husband and her three daughters had moved back to the central coast, where they could enjoy the sun and the surf lifestyle once again.")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("Numerous successful stories followed, each embodying Miranda’s trademark style: fast-paced and sexy rhythms; passionate, real-life characters; and enduring, memorable story lines. She has one credo when writing romances: Don’t bore the reader! Millions of fans worldwide agree she never does.")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "pagevi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-454c7f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/billionairesbrideofinnocencethe_fm03.vue
// module id = 66
// module chunks = 0